export default {
    data: `[
   {
      "id":"711297f6-2664-4176-bedb-46317ebb529b",
      "logicalname":"Cartoonist_background_Middelalder_skog_",
      "translations":{
         "nb_NO":"Skog",
         "sv_SE":"Skog",
         "en_US":"Forest"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":3,
      "hidden":2
   },
   {
      "id":"3787a983-1b2b-4f0d-8ebf-81a30c37c224",
      "logicalname":"content_image_2009.01.20.08.57.40_",
      "translations":{
         "nb_NO":"Hus",
         "sv_SE":"Hus",
         "en_US":"House"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         "byhus",
         "langhus"
      ],
      "tags":[
         
      ],
      "width":0,
      "height":0,
      "position":0,
      "hidden":2
   },
   {
      "id":"91107c71-21da-48ed-9644-d72f9c9c2a51",
      "logicalname":"content_image_2008.12.10.16.31.17_",
      "translations":{
         "nb_NO":"Kniv",
         "sv_SE":"Kniv",
         "en_US":"Knife"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":0,
      "height":0,
      "position":0,
      "hidden":2
   },
   {
      "id":"e2facc97-a1be-466e-9602-afbd3264909d",
      "logicalname":"content_image_2008.12.10.16.30.48_",
      "translations":{
         "nb_NO":"Bolle",
         "sv_SE":"Skål",
         "en_US":"Bowl"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":0,
      "height":0,
      "position":0,
      "hidden":2
   },
   {
      "id":"37096a8c-9dad-40d6-bb2d-dd0dbb810a54",
      "logicalname":"content_image_2008.12.10.16.29.27_",
      "translations":{
         "nb_NO":"Hund",
         "fi_FI":"Koira",
         "nn_NO":"Hund",
         "sv_SE":"Hund",
         "en_US":"Dog",
         "da_DK":"Hund"
      },
      "theme":"middle_age",
      "type":"animals",
      "moods":[
         "staar",
         "ligger"
      ],
      "tags":[
         
      ],
      "width":247,
      "height":155,
      "position":1,
      "hidden":2
   },
   {
      "id":"1c2f4f7e-2213-46df-81fc-82c04db1a132",
      "logicalname":"content_image_2009.01.20.08.56.59_",
      "translations":{
         "nb_NO":"Tigger bakfra",
         "fi_FI":"Kerjäläinen takaapäin",
         "nn_NO":"Tiggar bakfrå",
         "sv_SE":"Tiggare bakifrån",
         "en_US":"Beggar backside view",
         "da_DK":"Tigger bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":253,
      "height":367,
      "position":47,
      "hidden":2
   },
   {
      "id":"8c8558f9-db0b-407d-8f47-ad0ed9f805a6",
      "logicalname":"ma_konge_sitter_trone_",
      "translations":{
         "nb_NO":"Konge på trone",
         "fi_FI":"Kuningas istuu valtaistuimella",
         "nn_NO":"Konge på trone",
         "sv_SE":"Kung sittande på tron",
         "en_US":"King sitting on throne",
         "da_DK":"Konge på trone"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":231,
      "height":354,
      "position":48,
      "hidden":2
   },
   {
      "id":"6fd9dcdb-b9c1-44a0-a775-e83583e6c165",
      "logicalname":"ma_konge_star_",
      "translations":{
         "nb_NO":"Konge står",
         "fi_FI":"Kuningas seisoo",
         "nn_NO":"Konge står",
         "sv_SE":"Kung stående",
         "en_US":"King standing",
         "da_DK":"Konge stående"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":264,
      "height":408,
      "position":49,
      "hidden":2
   },
   {
      "id":"ac0cd38f-1412-41f0-aff8-b1bd40e5c27c",
      "logicalname":"content_image_2008.12.10.13.09.43_",
      "translations":{
         "nb_NO":"Bonde går",
         "fi_FI":"Talonpoika kävelee",
         "nn_NO":"Bonde går",
         "sv_SE":"Bonde går",
         "en_US":"Peasant walking",
         "da_DK":"Bonde går"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":190,
      "height":344,
      "position":0,
      "hidden":2
   },
   {
      "id":"0b1cc6fb-a435-40ac-a73f-19e035aaf9cb",
      "logicalname":"content_image_2008.12.10.13.09.54_",
      "translations":{
         "nb_NO":"Bonde kneler",
         "fi_FI":"Talonpoika polvistuu",
         "nn_NO":"Bonde kneler",
         "sv_SE":"Bonde knäböjer",
         "en_US":"Peasant kneeling",
         "da_DK":"Bonde knæler"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":187,
      "height":251,
      "position":1,
      "hidden":2
   },
   {
      "id":"bdbf8354-2f98-4694-94ae-5162379bc912",
      "logicalname":"content_image_2008.12.10.13.10.03_",
      "translations":{
         "nb_NO":"Bonde sitter",
         "fi_FI":"Talonpoika istuu",
         "nn_NO":"Bonde sit",
         "sv_SE":"Bonde sitter",
         "en_US":"Peasant sitting",
         "da_DK":"Bonde sidder"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":219,
      "height":303,
      "position":2,
      "hidden":2
   },
   {
      "id":"ad0e1798-c6d9-4e0b-9920-53aaa9fd0949",
      "logicalname":"content_image_2008.12.10.13.10.15_",
      "translations":{
         "nb_NO":"Bonde står",
         "fi_FI":"Talonpoika seisoo",
         "nn_NO":"Bonde står",
         "sv_SE":"Bonde står",
         "en_US":"Peasant standing",
         "da_DK":"Bonde står"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":186,
      "height":355,
      "position":3,
      "hidden":2
   },
   {
      "id":"b6b01a2d-6cc9-4d9c-ab2d-3d310549f156",
      "logicalname":"content_image_2008.12.10.13.10.24_",
      "translations":{
         "nb_NO":"Bonde syk",
         "fi_FI":"Talonpoika sairaana",
         "nn_NO":"Bonde sjuk",
         "sv_SE":"Bonde är sjuk",
         "en_US":"Peasant sick",
         "da_DK":"Bonde syg"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":360,
      "height":181,
      "position":4,
      "hidden":2
   },
   {
      "id":"a5acca2a-a087-4dc0-9970-05eb69f3ba18",
      "logicalname":"content_image_2009.01.20.08.53.48_",
      "translations":{
         "nb_NO":"Bonde bakfra",
         "fi_FI":"Talonpoika takaa",
         "nn_NO":"Bonde bakfrå",
         "sv_SE":"Bonde bakifrån",
         "en_US":"Peasant backside view",
         "da_DK":"Bonde bagfra"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":163,
      "height":334,
      "position":5,
      "hidden":2
   },
   {
      "id":"e44417f0-1d25-434f-ab06-718b6edf8d57",
      "logicalname":"content_image_2008.12.10.13.10.45_",
      "translations":{
         "nb_NO":"Bondebarn går",
         "fi_FI":"Maalaislapsi kävelee",
         "nn_NO":"Bondebarn går",
         "sv_SE":"Bondbarn går",
         "en_US":"Peasant child walking",
         "da_DK":"Bondebarn går"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":123,
      "height":215,
      "position":6,
      "hidden":2
   },
   {
      "id":"d6ef3e8d-d921-4333-b258-a864307e4f76",
      "logicalname":"content_image_2008.12.10.13.10.55_",
      "translations":{
         "nb_NO":"Bondebarn løper",
         "fi_FI":"Maalaislapsi juoksee",
         "nn_NO":"Bondebarn spring",
         "sv_SE":"Bondebarn springer",
         "en_US":"Peasant child running",
         "da_DK":"Bondebarn løber"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":159,
      "height":213,
      "position":7,
      "hidden":2
   },
   {
      "id":"3106759a-ccc3-4582-937c-5a3867d17825",
      "logicalname":"content_image_2008.12.10.13.11.03_",
      "translations":{
         "nb_NO":"Bondebarn sitter",
         "fi_FI":"Maalaislapsi istuu",
         "nn_NO":"Bondebarn sit",
         "sv_SE":"Bondbarn sitter",
         "en_US":"Peasant child sitting",
         "da_DK":"Bondebarn sidder"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":132,
      "height":193,
      "position":8,
      "hidden":2
   },
   {
      "id":"e1e692b9-7690-40c8-b082-b24913580267",
      "logicalname":"content_image_2008.12.10.13.11.13_",
      "translations":{
         "nb_NO":"Bondebarn står",
         "fi_FI":"Maalaislapsi seisoo",
         "nn_NO":"Bondebarn står",
         "sv_SE":"Bondbarn står",
         "en_US":"Peasant child standing",
         "da_DK":"Bondebarn står"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":149,
      "height":222,
      "position":9,
      "hidden":2
   },
   {
      "id":"9deb91e3-1c95-4f20-a559-2fe795fdc190",
      "logicalname":"content_image_2008.12.10.13.11.24_",
      "translations":{
         "nb_NO":"Bondebarn syk",
         "fi_FI":"Maalaislapsi sairaana",
         "nn_NO":"Bondebarn sjuk",
         "sv_SE":"Bondbarn är sjuk",
         "en_US":"Peasant child sick",
         "da_DK":"Bondebarn syg"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":213,
      "height":104,
      "position":10,
      "hidden":2
   },
   {
      "id":"24056986-e97f-488b-a61e-f96d03236c26",
      "logicalname":"content_image_2009.01.20.08.53.59_",
      "translations":{
         "nb_NO":"Bondebarn bakfra",
         "fi_FI":"Maalaislapsi takaapäin",
         "nn_NO":"Bondebarn bakfrå",
         "sv_SE":"Bondbarn bakifrån",
         "en_US":"Peasant child backside view",
         "da_DK":"Bondebarn bagfra"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "staar",
         "gaar",
         "loeper",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":123,
      "height":221,
      "position":11,
      "hidden":2
   },
   {
      "id":"27874da9-11e8-4998-a127-b68709609c36",
      "logicalname":"content_image_2008.12.10.13.11.41_",
      "translations":{
         "nb_NO":"Bondekone går",
         "fi_FI":"Maalaisnainen kävelee",
         "nn_NO":"Bondekone går",
         "sv_SE":"Bondhustru går",
         "en_US":"Peasant woman walking",
         "da_DK":"Bondekone går"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":237,
      "height":355,
      "position":12,
      "hidden":2
   },
   {
      "id":"054060fc-5188-411e-a079-65fabe68ccb9",
      "logicalname":"Cartoonist_background_Middelalder_hus_int_",
      "translations":{
         "nb_NO":"Hus inne",
         "fi_FI":"Talo sisältä",
         "nn_NO":"Hus inne",
         "sv_SE":"Hus insida",
         "en_US":"House - inside",
         "da_DK":"Hus inde"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":0,
      "hidden":2
   },
   {
      "id":"751bcad8-0efa-41ff-b3b9-07bb6a0924a1",
      "logicalname":"Cartoonist_background_Middelalder_kloster_ext_",
      "translations":{
         "nb_NO":"Kloster",
         "fi_FI":"Luostari",
         "nn_NO":"Kloster",
         "sv_SE":"Kloster",
         "en_US":"Monastery",
         "da_DK":"Kloster"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":1,
      "hidden":2
   },
   {
      "id":"75e80d2e-362d-4089-b490-cd54157eaf48",
      "logicalname":"Cartoonist_background_Middelalder_by_ext_",
      "translations":{
         "nb_NO":"Middeladerby",
         "fi_FI":"Keskiaikainen kaupunki",
         "nn_NO":"Middelalderby",
         "sv_SE":"Medeltidsstad",
         "en_US":"Middle Ages town",
         "da_DK":"Middelalderby"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":2,
      "hidden":2
   },
   {
      "id":"257cdf03-e81c-4b4e-9aee-1b44e02d3fd4",
      "logicalname":"Cartoonist_background_Middelalder_murvegg_",
      "translations":{
         "nb_NO":"Murvegg",
         "fi_FI":"Kiviseinä",
         "nn_NO":"Murvegg",
         "sv_SE":"Murad vägg",
         "en_US":"Stone wall",
         "da_DK":"Stenmur"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":3,
      "hidden":2
   },
   {
      "id":"15fd8686-178f-4a67-90cf-3922d59d7610",
      "logicalname":"Cartoonist_background_Middelalder_Sthalvard_int_",
      "translations":{
         "nb_NO":"St Halvard kirke",
         "fi_FI":"Pyhän Halvardin kirkko",
         "nn_NO":"St Halvards kyrkje",
         "sv_SE":"St Halvard kyrka",
         "en_US":"St. Halvard's church",
         "da_DK":"St. Halvard kirke"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":4,
      "hidden":2
   },
   {
      "id":"5bb350ab-f154-4a59-b440-0171462b7dd5",
      "logicalname":"Cartoonist_background_Middelalder_torg_",
      "translations":{
         "nb_NO":"Torg",
         "fi_FI":"Aukio",
         "nn_NO":"Torg",
         "sv_SE":"Torg",
         "en_US":"Square",
         "da_DK":"Torv"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":5,
      "hidden":2
   },
   {
      "id":"5dc7c61c-e691-4271-9e73-73caf3abbd1a",
      "logicalname":"Cartoonist_background_Middelalder_landsbygd_",
      "translations":{
         "nb_NO":"Landsbygd",
         "fi_FI":"Maaseutu",
         "nn_NO":"Landsbygd",
         "sv_SE":"Landsbygd",
         "en_US":"Countryside",
         "da_DK":"Landsby"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":6,
      "hidden":2
   },
   {
      "id":"e27ef7f0-8e5b-40c1-92bf-da27e1ca8ec6",
      "logicalname":"cartoonist_background_ma_borg_",
      "translations":{
         "nb_NO":"Borg",
         "fi_FI":"Linna",
         "nn_NO":"Borg",
         "sv_SE":"Slott",
         "en_US":"Castle",
         "da_DK":"Slot"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":7,
      "hidden":2
   },
   {
      "id":"41474f67-41d3-4bef-b4e9-bd4bcf5dbf40",
      "logicalname":"cartoonist_background_ma_borggard_",
      "translations":{
         "nb_NO":"Gårdsplass",
         "fi_FI":"Piha",
         "nn_NO":"Gardsplass",
         "sv_SE":"Gård",
         "en_US":"Courtyard",
         "da_DK":"Gårdsplads"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":8,
      "hidden":2
   },
   {
      "id":"93abc9ca-b841-4a6b-a1a8-64316a1a5ca1",
      "logicalname":"cartoonist_background_ma_tronsal_",
      "translations":{
         "nb_NO":"Tronsal",
         "fi_FI":"Valtaistuinsali",
         "nn_NO":"Tronsal",
         "sv_SE":"Tronrum",
         "en_US":"Throne room",
         "da_DK":"Tronsal"
      },
      "theme":"middle_age",
      "type":"backgrounds",
      "moods":[
         "dag",
         "natt"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":600,
      "position":9,
      "hidden":2
   },
   {
      "id":"778b67ee-7b70-482e-9e64-66668c1e6fb6",
      "logicalname":"content_image_2008.12.10.13.11.49_",
      "translations":{
         "nb_NO":"Bondekone kneler",
         "fi_FI":"Maalaisnainen polvistuu",
         "nn_NO":"Bondekone kneler",
         "sv_SE":"Bondhustru knäböjer",
         "en_US":"Peasant woman kneeling",
         "da_DK":"Bondekone knæler"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":188,
      "height":265,
      "position":13,
      "hidden":2
   },
   {
      "id":"85df620a-72cb-4326-bdc9-f3f7adcf4f6a",
      "logicalname":"content_image_2008.12.10.13.08.31_",
      "translations":{
         "nb_NO":"Adelskvinne syk",
         "fi_FI":"Aatelisnainen sairaana",
         "nn_NO":"Adelskvinne sjuk",
         "sv_SE":"Adelskvinna är sjuk",
         "en_US":"Noblewoman sick",
         "da_DK":"Adelskvinde syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":340,
      "height":143,
      "position":4,
      "hidden":2
   },
   {
      "id":"20543d40-9fb0-47c7-9a14-24cbbdf56137",
      "logicalname":"content_image_2008.12.10.13.11.56_",
      "translations":{
         "nb_NO":"Bondekone sitter",
         "fi_FI":"Maalaisnainen istuu",
         "nn_NO":"Bondekone sit",
         "sv_SE":"Bondhustru sitter",
         "en_US":"Peasant woman sitting",
         "da_DK":"Bondekone sidder"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":194,
      "height":328,
      "position":14,
      "hidden":2
   },
   {
      "id":"530f33c8-e97f-45c4-abfa-220bf0e33d0d",
      "logicalname":"content_image_2008.12.10.13.01.09_",
      "translations":{
         "nb_NO":"Adelskvinne går",
         "fi_FI":"Aatelisnainen kävelee",
         "nn_NO":"Adelskvinne går",
         "sv_SE":"Adelskvinna går",
         "en_US":"Noblewoman walking",
         "da_DK":"Adelskvinde går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":196,
      "height":338,
      "position":0,
      "hidden":2
   },
   {
      "id":"46cd8261-3d43-42dd-b6a2-0b332b5c6155",
      "logicalname":"content_image_2008.12.10.13.07.58_",
      "translations":{
         "nb_NO":"Adelskvinne kneler",
         "fi_FI":"Aatelisnainen polvistuu",
         "nn_NO":"Adelskvinne kneler",
         "sv_SE":"Adelskvinna knäböjer",
         "en_US":"Noblewoman kneeling",
         "da_DK":"Adelskvinde knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":184,
      "height":278,
      "position":1,
      "hidden":2
   },
   {
      "id":"1885f7b4-6d62-4bd9-8c60-c63a735912c8",
      "logicalname":"content_image_2008.12.10.13.08.10_",
      "translations":{
         "nb_NO":"Adelskvinne sitter",
         "fi_FI":"Aatelisnainen istuu",
         "nn_NO":"Adelskvinne sit",
         "sv_SE":"Adelskvinna sitter",
         "en_US":"Noblewoman sitting",
         "da_DK":"Adelskvinde sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":167,
      "height":297,
      "position":2,
      "hidden":2
   },
   {
      "id":"6b3bd9d7-59aa-4b92-addc-85bb3f5c47ed",
      "logicalname":"content_image_2008.12.10.13.08.20_",
      "translations":{
         "nb_NO":"Adelskvinne står",
         "fi_FI":"Aatelisnainen seisoo",
         "nn_NO":"Adelskvinne står",
         "sv_SE":"Adelskvinna står",
         "en_US":"Noblewoman standing",
         "da_DK":"Adelskvinde står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":201,
      "height":337,
      "position":3,
      "hidden":2
   },
   {
      "id":"bc75bd2e-a50c-4fcf-be73-ed9b212e8b7b",
      "logicalname":"content_image_2009.01.20.08.53.11_",
      "translations":{
         "nb_NO":"Adelskvinne bakfra",
         "fi_FI":"Aatelisnainen takaa",
         "nn_NO":"Adelskvinne bakfrå",
         "sv_SE":"Adelskvinna bakifrån",
         "en_US":"Noblewoman backside view",
         "da_DK":"Adelskvinde bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":145,
      "height":319,
      "position":5,
      "hidden":2
   },
   {
      "id":"a76e1397-578c-4463-bfa2-67d1f134fe2f",
      "logicalname":"content_image_2008.12.10.13.08.45_",
      "translations":{
         "nb_NO":"Adelsmann går",
         "fi_FI":"Aatelismies kävelee",
         "nn_NO":"Adelsmann går",
         "sv_SE":"Adelsman går",
         "en_US":"Nobleman walking",
         "da_DK":"Adelsmand går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":213,
      "height":370,
      "position":6,
      "hidden":2
   },
   {
      "id":"101c484c-cef2-4238-b791-9a6f70d5fd28",
      "logicalname":"content_image_2008.12.10.13.08.54_",
      "translations":{
         "nb_NO":"Adelsmann kneler",
         "fi_FI":"Aatelismies polvistuu",
         "nn_NO":"Adelsmann kneler",
         "sv_SE":"Adelsman knäböjer",
         "en_US":"Nobleman kneeling",
         "da_DK":"Adelsmand knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":233,
      "height":309,
      "position":7,
      "hidden":2
   },
   {
      "id":"01c7001c-e4d4-4876-8006-134d1d1430dd",
      "logicalname":"content_image_2008.12.10.13.09.01_",
      "translations":{
         "nb_NO":"Adelsmann sitter",
         "fi_FI":"Aatelismies istuu",
         "nn_NO":"Adelsmann sit",
         "sv_SE":"Adelsman sitter",
         "en_US":"Nobleman sitting",
         "da_DK":"Adelsmand sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":214,
      "height":326,
      "position":8,
      "hidden":2
   },
   {
      "id":"efa11fbf-ceaf-495b-949a-7561e28c6fdd",
      "logicalname":"content_image_2008.12.10.13.09.12_",
      "translations":{
         "nb_NO":"Adelsmann står",
         "fi_FI":"Aatelismies seisoo",
         "nn_NO":"Adelsmann står",
         "sv_SE":"Adelsman står",
         "en_US":"Nobleman standing",
         "da_DK":"Adelsmand står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":283,
      "height":381,
      "position":9,
      "hidden":2
   },
   {
      "id":"acc568ff-afad-4058-8865-f94a6a765a7c",
      "logicalname":"content_image_2008.12.10.13.09.21_",
      "translations":{
         "nb_NO":"Adelsmann syk",
         "fi_FI":"Aatelismies sairaana",
         "nn_NO":"Adelsmann sjuk",
         "sv_SE":"Adelsman är sjuk",
         "en_US":"Nobleman sick",
         "da_DK":"Adelsmand syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":364,
      "height":132,
      "position":10,
      "hidden":2
   },
   {
      "id":"32a583d1-f16d-4b73-8628-c6805aac155c",
      "logicalname":"content_image_2009.01.20.08.53.37_",
      "translations":{
         "nb_NO":"Adelsmann bakfra",
         "fi_FI":"Aatelismies takaapäin",
         "nn_NO":"Adelsmann bakfrå",
         "sv_SE":"Adelsman bakifrån",
         "en_US":"Nobleman backside view",
         "da_DK":"Adelsmand bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":223,
      "height":372,
      "position":11,
      "hidden":2
   },
   {
      "id":"8e290853-31a4-4bbc-b52c-0c12ab969830",
      "logicalname":"content_image_2008.12.10.13.12.34_",
      "translations":{
         "nb_NO":"Borger går",
         "fi_FI":"Porvari kävelee",
         "nn_NO":"Borgar går",
         "sv_SE":"Borgare går",
         "en_US":"Townsman walking",
         "da_DK":"Borger går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":207,
      "height":358,
      "position":12,
      "hidden":2
   },
   {
      "id":"7f823292-62ab-4a68-8a05-9b1d27bf651f",
      "logicalname":"content_image_2008.12.10.13.12.41_",
      "translations":{
         "nb_NO":"Borger kneler",
         "fi_FI":"Porvari polvistuu",
         "nn_NO":"Borgar kneler",
         "sv_SE":"Borgare knäböjer",
         "en_US":"Townsman kneeling",
         "da_DK":"Borger knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":234,
      "height":286,
      "position":13,
      "hidden":2
   },
   {
      "id":"44acb9e8-2d58-4dde-ae0d-601984440f94",
      "logicalname":"content_image_2008.12.10.13.12.50_",
      "translations":{
         "nb_NO":"Borger sitter",
         "fi_FI":"Porvari istuu",
         "nn_NO":"Borger sit",
         "sv_SE":"Borgare sitter",
         "en_US":"Townsman sitting",
         "da_DK":"Borger sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":184,
      "height":335,
      "position":14,
      "hidden":2
   },
   {
      "id":"c0f7f55b-d198-416b-a8be-567ebe35b11c",
      "logicalname":"content_image_2008.12.10.13.12.57_",
      "translations":{
         "nb_NO":"Borger står",
         "fi_FI":"Porvari seisoo",
         "nn_NO":"Borgar står",
         "sv_SE":"Borgare står",
         "en_US":"Townsman standing",
         "da_DK":"Borger står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":198,
      "height":369,
      "position":15,
      "hidden":2
   },
   {
      "id":"3d7ca30c-68c2-44d3-b5e4-a32ab05ed0a1",
      "logicalname":"content_image_2008.12.10.13.13.05_",
      "translations":{
         "nb_NO":"Borger syk",
         "fi_FI":"Porvari sairaana",
         "nn_NO":"Borgar sjuk",
         "sv_SE":"Borgare är sjuk",
         "en_US":"Townsman sick",
         "da_DK":"Borger syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":344,
      "height":213,
      "position":16,
      "hidden":2
   },
   {
      "id":"da83266b-1402-430b-a4b7-98ab757b5d54",
      "logicalname":"content_image_2009.01.20.08.54.24_",
      "translations":{
         "nb_NO":"Borger bakfra",
         "fi_FI":"Porvari takaapäin",
         "nn_NO":"Borgar bakfrå",
         "sv_SE":"Borgare är bakifrån",
         "en_US":"Townsman back view",
         "da_DK":"Borger bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":188,
      "height":366,
      "position":17,
      "hidden":2
   },
   {
      "id":"587860f4-7f18-433e-94c5-1dbd0bf36314",
      "logicalname":"content_image_2008.12.10.13.13.23_",
      "translations":{
         "nb_NO":"Borgerkvinne går",
         "fi_FI":"Porvarisnainen kävelee",
         "nn_NO":"Borgarkvinne går",
         "sv_SE":"Borgarkvinna går",
         "en_US":"Townswoman walking",
         "da_DK":"Borgerkvinde går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":207,
      "height":333,
      "position":18,
      "hidden":2
   },
   {
      "id":"3ea6ca7e-0d0a-4fd1-a95c-0fd0bfa1c6de",
      "logicalname":"content_image_2008.12.10.13.13.41_",
      "translations":{
         "nb_NO":"Borgerkvinne kneler",
         "fi_FI":"Porvarisnainen polvistuu",
         "nn_NO":"Borgarkvinne kneler",
         "sv_SE":"Borgarkvinna knäböjer",
         "en_US":"Townswoman kneeling",
         "da_DK":"Borgerkvinde knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":190,
      "height":298,
      "position":19,
      "hidden":2
   },
   {
      "id":"54c01541-b352-48d1-adc2-010101aa9456",
      "logicalname":"content_image_2008.12.10.13.13.48_",
      "translations":{
         "nb_NO":"Borgerkvinne sitter",
         "fi_FI":"Porvarisnainen istuu",
         "nn_NO":"Borgarkvinne sit",
         "sv_SE":"Borgarkvinna sitter",
         "en_US":"Townswoman sitting",
         "da_DK":"Borgerkvinde sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":190,
      "height":288,
      "position":20,
      "hidden":2
   },
   {
      "id":"cbb67355-db5a-4d27-9307-8e405b06d723",
      "logicalname":"content_image_2008.12.10.13.13.56_",
      "translations":{
         "nb_NO":"Borgerkvinne står",
         "fi_FI":"Porvarisnainen seisoo",
         "nn_NO":"Borgarkvinne står",
         "sv_SE":"Borgarkvinna står",
         "en_US":"Townswoman standing",
         "da_DK":"Borgerkvinde står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":219,
      "height":330,
      "position":21,
      "hidden":2
   },
   {
      "id":"b7346f68-93c4-471a-a4f2-42375f392b2e",
      "logicalname":"content_image_2008.12.10.13.14.05_",
      "translations":{
         "nb_NO":"Borgerkvinne syk",
         "fi_FI":"Porvarisnainen sairaana",
         "nn_NO":"Borgarkvinne sjuk",
         "sv_SE":"Borgarkvinna sjuk",
         "en_US":"Townswoman sick",
         "da_DK":"Borgerkvinde syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":337,
      "height":164,
      "position":22,
      "hidden":2
   },
   {
      "id":"59d73ffa-6188-4c6b-8e7b-fb3b1bc03243",
      "logicalname":"content_image_2009.01.20.08.54.39_",
      "translations":{
         "nb_NO":"Borgerkvinne bakfra",
         "fi_FI":"Porvarisnainen takaa",
         "nn_NO":"Borgarkvinne bakfrå",
         "sv_SE":"Borgarkvinna bakifrån",
         "en_US":"Townswoman backside view",
         "da_DK":"Borgerkvinde bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":184,
      "height":330,
      "position":23,
      "hidden":2
   },
   {
      "id":"a9494ca5-ae3a-45a1-9ec8-dc1884a04a35",
      "logicalname":"content_image_2008.12.10.13.14.33_",
      "translations":{
         "nb_NO":"Håndverker går",
         "fi_FI":"Käsityöläinen kävelee",
         "nn_NO":"Handverkar går",
         "sv_SE":"Hantverkare går",
         "en_US":"Artisan walking",
         "da_DK":"Håndværker går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":241,
      "height":364,
      "position":24,
      "hidden":2
   },
   {
      "id":"e8820426-036f-486b-91fa-d793da68cf59",
      "logicalname":"content_image_2008.12.10.13.14.44_",
      "translations":{
         "nb_NO":"Håndverker kneler",
         "fi_FI":"Käsityöläinen polvistuu",
         "nn_NO":"Handverkar kneler",
         "sv_SE":"Hantverkare knäböjer",
         "en_US":"Artisan kneeling",
         "da_DK":"Håndværker knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":219,
      "height":307,
      "position":25,
      "hidden":2
   },
   {
      "id":"3377335c-587a-4445-94d2-2bc96c6f02b3",
      "logicalname":"content_image_2008.12.10.13.14.56_",
      "translations":{
         "nb_NO":"Håndverker sitter",
         "fi_FI":"Käsityöläinen istuu",
         "nn_NO":"Handverkar sit",
         "sv_SE":"Hantverkare sitter",
         "en_US":"Artisan sitting",
         "da_DK":"Håndværker sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":188,
      "height":331,
      "position":26,
      "hidden":2
   },
   {
      "id":"9d700d8d-6f2d-47e0-aba1-d9614b3ddc90",
      "logicalname":"content_image_2008.12.10.13.15.07_",
      "translations":{
         "nb_NO":"Håndverker står",
         "fi_FI":"Käsityöläinen seisoo",
         "nn_NO":"Handverkar står",
         "sv_SE":"Hantverkare står",
         "en_US":"Artisan standing",
         "da_DK":"Håndværker står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":196,
      "height":365,
      "position":27,
      "hidden":2
   },
   {
      "id":"52a3f49c-cf8b-452a-90d7-408246743b9d",
      "logicalname":"content_image_2008.12.10.13.15.20_",
      "translations":{
         "nb_NO":"Håndverker syk",
         "fi_FI":"Käsityöläinen sairaana",
         "nn_NO":"Handverkar sjuk",
         "sv_SE":"Hantverkare är sjuk",
         "en_US":"Artisan sick",
         "da_DK":"Håndværker syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":362,
      "height":174,
      "position":28,
      "hidden":2
   },
   {
      "id":"06a4900b-97b3-49d3-a233-457e1523f22e",
      "logicalname":"content_image_2009.01.20.08.54.53_",
      "translations":{
         "nb_NO":"Håndverker bakfra",
         "fi_FI":"Käsityöläinen takaa",
         "nn_NO":"Handverkar bakfrå",
         "sv_SE":"Hantverkare bakifrån",
         "en_US":"Artisan backside view",
         "da_DK":"Håndværker bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":218,
      "height":356,
      "position":29,
      "hidden":2
   },
   {
      "id":"e57e4464-f2f2-4e96-9760-8e182db28284",
      "logicalname":"content_image_2008.12.10.13.15.42_",
      "translations":{
         "nb_NO":"Kjøpmann går",
         "fi_FI":"Kauppias kävelee",
         "nn_NO":"Kjøpmann går",
         "sv_SE":"Köpman går",
         "en_US":"Merchant walking",
         "da_DK":"Købmand går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":196,
      "height":301,
      "position":30,
      "hidden":2
   },
   {
      "id":"7e061ba6-5969-4df5-9d95-50b9e31d27ca",
      "logicalname":"content_image_2008.12.10.13.15.49_",
      "translations":{
         "nb_NO":"Kjøpmann kneler",
         "fi_FI":"Kauppias polvistuu",
         "nn_NO":"Kjøpmann kneler",
         "sv_SE":"Köpman knäböjer",
         "en_US":"Merchant kneeling",
         "da_DK":"Købmand knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":222,
      "height":249,
      "position":31,
      "hidden":2
   },
   {
      "id":"f2cedfb4-9709-4528-99f2-db3c2b2aa16e",
      "logicalname":"content_image_2008.12.10.13.15.56_",
      "translations":{
         "nb_NO":"Kjøpmann sitter",
         "fi_FI":"Kauppias istuu",
         "nn_NO":"Kjøpmann sit",
         "sv_SE":"Köpman sitter",
         "en_US":"Merchant sitting",
         "da_DK":"Købmand sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":195,
      "height":280,
      "position":32,
      "hidden":2
   },
   {
      "id":"bf80d48e-0147-4902-befe-84042cdba0ac",
      "logicalname":"content_image_2008.12.10.13.16.04_",
      "translations":{
         "nb_NO":"Kjøpmann står",
         "fi_FI":"Kauppias seisoo",
         "nn_NO":"Kjøpmann står",
         "sv_SE":"Köpman står",
         "en_US":"Merchant standing",
         "da_DK":"Købmand står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":214,
      "height":296,
      "position":33,
      "hidden":2
   },
   {
      "id":"460f4385-abef-475b-b4ce-954ac04306f3",
      "logicalname":"ma_tre_",
      "translations":{
         "nb_NO":"Tre",
         "fi_FI":"Tree",
         "nn_NO":"Tre",
         "sv_SE":"Tre",
         "en_US":"Tree",
         "da_DK":"Tree"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":384,
      "height":529,
      "position":24,
      "hidden":2
   },
   {
      "id":"03187add-8168-4c40-b5de-b4edba747266",
      "logicalname":"ma_trone_",
      "translations":{
         "nb_NO":"Trone",
         "fi_FI":"Valtaistuin",
         "nn_NO":"Trone",
         "sv_SE":"Tron",
         "en_US":"Throne",
         "da_DK":"Trone"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":235,
      "height":408,
      "position":25,
      "hidden":2
   },
   {
      "id":"d993f550-90f3-4cf6-8fde-f8dfee6d5de8",
      "logicalname":"content_image_2008.12.10.13.16.11_",
      "translations":{
         "nb_NO":"Kjøpmann syk",
         "fi_FI":"Kauppias sairaana",
         "nn_NO":"Kjøpmann syk",
         "sv_SE":"Köpman sjuk",
         "en_US":"Merchant sick",
         "da_DK":"Købmand syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":294,
      "height":99,
      "position":34,
      "hidden":2
   },
   {
      "id":"f188631a-f7af-47c4-9cea-8fd9ec978062",
      "logicalname":"content_image_2009.01.20.08.55.10_",
      "translations":{
         "nb_NO":"Kjøpmann bakfra",
         "fi_FI":"Kauppias takaapäin",
         "nn_NO":"Kjøpmann bakfrå",
         "sv_SE":"Köpman bakifrån",
         "en_US":"Merchant bakside view",
         "da_DK":"Købmand bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":223,
      "height":293,
      "position":35,
      "hidden":2
   },
   {
      "id":"2b737f04-ab97-438b-94f1-4014c4e7ed3f",
      "logicalname":"content_image_2008.12.10.13.17.15_",
      "translations":{
         "nb_NO":"Musikant går",
         "fi_FI":"Musikantti kävelee",
         "nn_NO":"Musikant går",
         "sv_SE":"Musikant går",
         "en_US":"Minstrel walking",
         "da_DK":"Musikant går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":195,
      "height":337,
      "position":36,
      "hidden":2
   },
   {
      "id":"90731aa6-a0f7-4113-a895-018cfb1b4d94",
      "logicalname":"content_image_2008.12.10.13.17.22_",
      "translations":{
         "nb_NO":"Musikant kneler",
         "fi_FI":"Musikantti polvistuu",
         "nn_NO":"Musikant kneler",
         "sv_SE":"Musikant knäböjer",
         "en_US":"Minstrel kneeling",
         "da_DK":"Musikant knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":171,
      "height":267,
      "position":37,
      "hidden":2
   },
   {
      "id":"26c926ed-94df-4c09-8941-a8933564c2d5",
      "logicalname":"content_image_2008.12.10.13.17.30_",
      "translations":{
         "nb_NO":"Musikant sitter",
         "fi_FI":"Musikantti istuu",
         "nn_NO":"Musikant sit",
         "sv_SE":"Musikant sitter",
         "en_US":"Minstrel sitting",
         "da_DK":"Musikant sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":199,
      "height":306,
      "position":38,
      "hidden":2
   },
   {
      "id":"bc580c22-0ac7-41a6-b5f3-76580db6a52d",
      "logicalname":"content_image_2008.12.10.13.17.37_",
      "translations":{
         "nb_NO":"Musikant står",
         "fi_FI":"Musikantti seisoo",
         "nn_NO":"Musikant står",
         "sv_SE":"Musikant står",
         "en_US":"Minstrel standing",
         "da_DK":"Musikant står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":179,
      "height":336,
      "position":39,
      "hidden":2
   },
   {
      "id":"b0bff7a2-b4cb-4f40-a6a0-a193037b4742",
      "logicalname":"content_image_2008.12.10.13.17.52_",
      "translations":{
         "nb_NO":"Musikant syk",
         "fi_FI":"Musikantti sairaana",
         "nn_NO":"Musikant sjuk",
         "sv_SE":"Musikant är sjuk",
         "en_US":"Minstrel sick",
         "da_DK":"Musikant syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":333,
      "height":134,
      "position":40,
      "hidden":2
   },
   {
      "id":"8f4568ae-5125-4cfa-ad63-c9c6f158102c",
      "logicalname":"content_image_2009.01.20.08.55.37_",
      "translations":{
         "nb_NO":"Musikkant bakfra",
         "fi_FI":"Musikantti takaapäin",
         "nn_NO":"Musikkant bakfrå",
         "sv_SE":"Musikant bakifrån",
         "en_US":"Minstrel backside view",
         "da_DK":"Musikant bagfra"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":178,
      "height":327,
      "position":41,
      "hidden":2
   },
   {
      "id":"66a0a6fa-0938-4143-88e4-342daa1f1057",
      "logicalname":"content_image_2008.12.10.13.23.21_",
      "translations":{
         "nb_NO":"Tigger går",
         "fi_FI":"Kerjäläinen kävelee",
         "nn_NO":"Tiggar går",
         "sv_SE":"Tiggare går",
         "en_US":"Beggar walking",
         "da_DK":"Tigger går"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":270,
      "height":364,
      "position":42,
      "hidden":2
   },
   {
      "id":"2958f790-c677-43c5-96ef-6536cd1836f2",
      "logicalname":"content_image_2008.12.10.13.23.28_",
      "translations":{
         "nb_NO":"Tigger kneler",
         "fi_FI":"Kerjäläinen polvistuu",
         "nn_NO":"Tiggar kneler",
         "sv_SE":"Tiggare knäböjer",
         "en_US":"Beggar kneeling",
         "da_DK":"Tigger knæler"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":198,
      "height":290,
      "position":43,
      "hidden":2
   },
   {
      "id":"8620b2ba-2794-4ab4-8249-168c253c8130",
      "logicalname":"content_image_2008.12.10.13.23.40_",
      "translations":{
         "nb_NO":"Tigger sitter",
         "fi_FI":"Kerjäläinen istuu",
         "nn_NO":"Tiggar sit",
         "sv_SE":"Tiggare sitter",
         "en_US":"Beggar sitting",
         "da_DK":"Tigger sidder"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":325,
      "height":306,
      "position":44,
      "hidden":2
   },
   {
      "id":"5f08445f-697d-47d7-ae19-d9d73badc150",
      "logicalname":"content_image_2008.12.10.13.23.49_",
      "translations":{
         "nb_NO":"Tigger står",
         "fi_FI":"Kerjäläinen seisoo",
         "nn_NO":"Tiggar står",
         "sv_SE":"Tiggare står",
         "en_US":"Beggar standing",
         "da_DK":"Tigger står"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":212,
      "height":373,
      "position":45,
      "hidden":2
   },
   {
      "id":"92613089-d21b-48c3-b255-fd23c59d7b31",
      "logicalname":"content_image_2008.12.10.13.23.58_",
      "translations":{
         "nb_NO":"Tigger syk",
         "fi_FI":"Kerjäläinen sairaana",
         "nn_NO":"Tiggar sjuk",
         "sv_SE":"Tiggare är sjuk",
         "en_US":"Beggar sick",
         "da_DK":"Tigger syg"
      },
      "theme":"middle_age",
      "type":"townspeople",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":392,
      "height":181,
      "position":46,
      "hidden":2
   },
   {
      "id":"553f48e5-f677-4196-b59a-2ad30f7fe5ac",
      "logicalname":"content_image_2008.12.10.13.12.05_",
      "translations":{
         "nb_NO":"Bondekone står",
         "fi_FI":"Maalaisnainen seisoo",
         "nn_NO":"Bondekone står",
         "sv_SE":"Bondhustru står",
         "en_US":"Peasant woman standing",
         "da_DK":"Bondekone står"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":214,
      "height":351,
      "position":15,
      "hidden":2
   },
   {
      "id":"19663506-e247-4d57-999c-b5b8b20fcc21",
      "logicalname":"content_image_2008.12.10.13.12.12_",
      "translations":{
         "nb_NO":"Bondekone syk",
         "fi_FI":"Maalaisnainen sairaana",
         "nn_NO":"Bondekone sjuk",
         "sv_SE":"Bondhustru är sjuk",
         "en_US":"Peasant woman sick",
         "da_DK":"Bondekone syg"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":373,
      "height":153,
      "position":16,
      "hidden":2
   },
   {
      "id":"8bbb0faf-e63c-49bf-ae1e-73b1f8306767",
      "logicalname":"content_image_2009.01.20.08.54.10_",
      "translations":{
         "nb_NO":"Bondekone bakfra",
         "fi_FI":"Maalaisnainen takaapäin",
         "nn_NO":"Bondekone bakfrå",
         "sv_SE":"Bondhustru bakifrån",
         "en_US":"Peasant woman backside view",
         "da_DK":"Bondekone bagfra"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":177,
      "height":346,
      "position":17,
      "hidden":2
   },
   {
      "id":"dff77227-5a72-4e3e-92d8-c6bc8cd543d0",
      "logicalname":"content_image_2008.12.10.13.20.39_",
      "translations":{
         "nb_NO":"Storbonde går",
         "fi_FI":"Suurtilallinen kävelee",
         "nn_NO":"Storbonde går",
         "sv_SE":"Storbonde går",
         "en_US":"Landowner walking",
         "da_DK":"Storbonde går"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":220,
      "height":372,
      "position":18,
      "hidden":2
   },
   {
      "id":"4401202b-e566-4520-a28f-5dc300aea58c",
      "logicalname":"content_image_2008.12.10.13.20.45_",
      "translations":{
         "nb_NO":"Storbonde kneler",
         "fi_FI":"Suurtilallinen polvistuu",
         "nn_NO":"Storbonde kneler",
         "sv_SE":"Storbonde knäböjer",
         "en_US":"Landowner kneeling",
         "da_DK":"Storbonde knæler"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":178,
      "height":301,
      "position":19,
      "hidden":2
   },
   {
      "id":"f7ed9e43-c07a-4205-a1d9-0b0dbeada1f0",
      "logicalname":"content_image_2008.12.10.13.20.52_",
      "translations":{
         "nb_NO":"Storbonde sitter",
         "fi_FI":"Suurtilallinen istuu",
         "nn_NO":"Storbonde sit",
         "sv_SE":"Storbonde sitter",
         "en_US":"Landowner sitting",
         "da_DK":"Storbonde sidder"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":236,
      "height":342,
      "position":20,
      "hidden":2
   },
   {
      "id":"0eba42a2-f6a4-4259-b718-92b16cce4a0f",
      "logicalname":"content_image_2008.12.10.13.20.59_",
      "translations":{
         "nb_NO":"Storbonde står",
         "fi_FI":"Suurtilallinen seisoo",
         "nn_NO":"Storbonde står",
         "sv_SE":"Storbonde står",
         "en_US":"Landowner standing",
         "da_DK":"Storbonde står"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":198,
      "height":371,
      "position":21,
      "hidden":2
   },
   {
      "id":"34710a3c-c22a-4b80-ac20-cfedfdff20ff",
      "logicalname":"content_image_2008.12.10.13.21.07_",
      "translations":{
         "nb_NO":"Storbonde syk",
         "fi_FI":"Suurtilallinen sairaana",
         "nn_NO":"Storbonde sjuk",
         "sv_SE":"Storbonde är sjuk",
         "en_US":"Landowner sick",
         "da_DK":"Storbonde syg"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":366,
      "height":115,
      "position":22,
      "hidden":2
   },
   {
      "id":"8b1c9009-1cef-4173-ab33-a541895838c5",
      "logicalname":"content_image_2009.01.20.08.56.19_",
      "translations":{
         "nb_NO":"Storbonde bakfra",
         "fi_FI":"Suurtilallinen takaapäin",
         "nn_NO":"Storbonde bakfrå",
         "sv_SE":"Storbonde bakifrån",
         "en_US":"Landowner backside view",
         "da_DK":"Storbonde bagfra"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":256,
      "height":369,
      "position":23,
      "hidden":2
   },
   {
      "id":"7ce4ee37-a301-4e7b-9a7d-69c88fa878f2",
      "logicalname":"content_image_2008.12.10.13.22.29_",
      "translations":{
         "nb_NO":"Storbondebarn går",
         "fi_FI":"Suurtilallisen vaimo kävelee",
         "nn_NO":"Storbondebarn går",
         "sv_SE":"Storbondebarn går",
         "en_US":"Landowner's child walking",
         "da_DK":"Storbondebarn går"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":195,
      "height":377,
      "position":24,
      "hidden":2
   },
   {
      "id":"34ef52ab-3de5-4137-a6b3-6b7e7a16bb4d",
      "logicalname":"content_image_2008.12.10.13.22.37_",
      "translations":{
         "nb_NO":"Storbondekone kneler",
         "fi_FI":"Suurtilallisen vaimo polvistuu",
         "nn_NO":"Storbondekone kneler",
         "sv_SE":"Storbondens hustru knäböjer",
         "en_US":"Landowner's wife kneeling",
         "da_DK":"Storbondekone knæler"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":214,
      "height":298,
      "position":25,
      "hidden":2
   },
   {
      "id":"c69e4c5c-5d72-48e9-9b54-f4a0e8939c03",
      "logicalname":"content_image_2008.12.10.13.22.46_",
      "translations":{
         "nb_NO":"Storbondekone sitter",
         "fi_FI":"Suurtilallisen vaimo istuu",
         "nn_NO":"Storbondekone sit",
         "sv_SE":"Storbondens hustru sitter",
         "en_US":"Landowner's wife sitting",
         "da_DK":"Storbondekone sidder"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":213,
      "height":356,
      "position":26,
      "hidden":2
   },
   {
      "id":"ce275763-f218-4c84-89b0-5d7ff01bc217",
      "logicalname":"content_image_2008.12.10.13.22.55_",
      "translations":{
         "nb_NO":"Storbondekone står",
         "fi_FI":"Suurtilallisen vaimo seisoo",
         "nn_NO":"Storbondekone står",
         "sv_SE":"Storbondehustru står",
         "en_US":"Landowner's wife standing",
         "da_DK":"Storbondekone står"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":236,
      "height":367,
      "position":27,
      "hidden":2
   },
   {
      "id":"c677121e-fbe2-43eb-86a2-eef515033c2d",
      "logicalname":"content_image_2008.12.10.13.23.07_",
      "translations":{
         "nb_NO":"Storbondekone syk",
         "fi_FI":"Suurtilallisen vaimo sairaana",
         "nn_NO":"Storbondekone sjuk",
         "sv_SE":"Storbondens hustru är sjuk",
         "en_US":"Landowner's wife sick",
         "da_DK":"Storbondekone syg"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":382,
      "height":114,
      "position":28,
      "hidden":2
   },
   {
      "id":"25418c00-19b2-4711-b3da-ac78bc3f2fbe",
      "logicalname":"content_image_2009.01.20.08.56.47_",
      "translations":{
         "nb_NO":"Storbondekone bakfra",
         "fi_FI":"Suurtilallisen vaimo takaapäin",
         "nn_NO":"Storbondekone bakfrå",
         "sv_SE":"Storbondehustru bakifrån",
         "en_US":"Landowner's wife backside view",
         "da_DK":"Storbondekone bagfra"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":198,
      "height":358,
      "position":29,
      "hidden":2
   },
   {
      "id":"47d20d06-e3b8-4bdb-91b5-81399fa14de5",
      "logicalname":"content_image_2008.12.10.13.21.28_",
      "translations":{
         "nb_NO":"Storbondekone går",
         "fi_FI":"Suurtilallisen vaimo kävelee",
         "nn_NO":"Storbondekone går",
         "sv_SE":"Storbondehustru går",
         "en_US":"Landowner's wife walking",
         "da_DK":"Storbondekone går"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":135,
      "height":222,
      "position":30,
      "hidden":2
   },
   {
      "id":"70031f3d-d81a-4392-9c3d-ccea9e184873",
      "logicalname":"content_image_2008.12.10.13.21.43_",
      "translations":{
         "nb_NO":"Storbondebarn løper",
         "fi_FI":"Suurtilallisen lapsi juoksee",
         "nn_NO":"Storbondebarn spring",
         "sv_SE":"Storbondebarn springer",
         "en_US":"Landowner's child running",
         "da_DK":"Storbondebarn løber"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":178,
      "height":222,
      "position":31,
      "hidden":2
   },
   {
      "id":"2755ed74-e18f-4d63-ae93-5afb548f649d",
      "logicalname":"content_image_2008.12.10.13.21.51_",
      "translations":{
         "nb_NO":"Storbondebarn sitter",
         "fi_FI":"Suurtilallisen lapsi istuu",
         "nn_NO":"Storbondebarn sit",
         "sv_SE":"Storbondebarn sitter",
         "en_US":"Landowner's child sitting",
         "da_DK":"Storbondebarn sidder"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":140,
      "height":201,
      "position":32,
      "hidden":2
   },
   {
      "id":"74d193c4-6a20-420e-b60d-d914a5ad396b",
      "logicalname":"content_image_2008.12.10.13.22.01_",
      "translations":{
         "nb_NO":"Storbondebarn står",
         "fi_FI":"Suurtilallisen lapsi seisoo",
         "nn_NO":"Storbondebarn står",
         "sv_SE":"Storbondebarn står",
         "en_US":"Landowner's child standing",
         "da_DK":"Storbondebarn står"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":135,
      "height":228,
      "position":33,
      "hidden":2
   },
   {
      "id":"7ef09c75-833b-4eeb-b118-d82cd1fff10d",
      "logicalname":"content_image_2008.12.10.13.22.12_",
      "translations":{
         "nb_NO":"Storbondebarn syk",
         "fi_FI":"Suurtilallisen lapsi sairaana",
         "nn_NO":"Storbondebarn sjuk",
         "sv_SE":"Storbondebarn är sjuk",
         "en_US":"Landowner's child sick",
         "da_DK":"Storbondebarn syg"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":218,
      "height":122,
      "position":34,
      "hidden":2
   },
   {
      "id":"9e56477c-0e52-4e3d-8458-3504d16cc584",
      "logicalname":"content_image_2009.01.20.08.56.31_",
      "translations":{
         "nb_NO":"Storbondebarn bakfra",
         "fi_FI":"Suurtilallisen lapsi takaapäin",
         "nn_NO":"Storbondebarn bakfrå",
         "sv_SE":"Storbondebarn bakifrån",
         "en_US":"Landowner's child backside view",
         "da_DK":"Storbondebarn bagfra"
      },
      "theme":"middle_age",
      "type":"farmers",
      "moods":[
         "staar",
         "gaar",
         "loeper",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":140,
      "height":215,
      "position":35,
      "hidden":2
   },
   {
      "id":"56524109-edd3-4e33-a4bf-9a8033b38967",
      "logicalname":"content_image_2008.12.10.13.19.04_",
      "translations":{
         "nb_NO":"Pave går",
         "fi_FI":"Paavi kävelee",
         "nn_NO":"Pave går",
         "sv_SE":"Påve går",
         "en_US":"Pope walking",
         "da_DK":"Pave går"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":232,
      "height":381,
      "position":0,
      "hidden":2
   },
   {
      "id":"9b5c57e0-929e-4df7-8a5a-f4235f98b015",
      "logicalname":"content_image_2008.12.10.13.19.12_",
      "translations":{
         "nb_NO":"Pave kneler",
         "fi_FI":"Paavi polvistuu",
         "nn_NO":"Pave kneler",
         "sv_SE":"Påve knäböjer",
         "en_US":"Pope kneeling",
         "da_DK":"Pave knæler"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":233,
      "height":306,
      "position":1,
      "hidden":2
   },
   {
      "id":"b6dd718c-bad9-4a07-ad09-bb8d95f159de",
      "logicalname":"content_image_2008.12.10.13.19.19_",
      "translations":{
         "nb_NO":"Pave sitter",
         "fi_FI":"Paavi istuu",
         "nn_NO":"Pave sit",
         "sv_SE":"Påve sitter",
         "en_US":"Pope sitting",
         "da_DK":"Pave sidder"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":195,
      "height":353,
      "position":2,
      "hidden":2
   },
   {
      "id":"fb9067ee-4cd3-48ea-b70f-2ffc4cbd2486",
      "logicalname":"content_image_2008.12.10.13.19.28_",
      "translations":{
         "nb_NO":"Pave står",
         "fi_FI":"Paavi seisoo",
         "nn_NO":"Pave står",
         "sv_SE":"Påve står",
         "en_US":"Pope standing",
         "da_DK":"Pave står"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":235,
      "height":387,
      "position":3,
      "hidden":2
   },
   {
      "id":"2f312ec7-8841-4cfb-9c7a-5e80bfa0b0c7",
      "logicalname":"content_image_2008.12.10.13.19.36_",
      "translations":{
         "nb_NO":"Pave syk",
         "fi_FI":"Paavi sairaana",
         "nn_NO":"Pave sjuk",
         "sv_SE":"Påve är sjuk",
         "en_US":"Pope sick",
         "da_DK":"Pave syg"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":387,
      "height":149,
      "position":4,
      "hidden":2
   },
   {
      "id":"fd06d8c8-bc5b-4e32-9793-0834197f71c5",
      "logicalname":"content_image_2009.01.20.08.55.59_",
      "translations":{
         "nb_NO":"Pave bakfra",
         "fi_FI":"Paavi takaapäin",
         "nn_NO":"Pave bakfrå",
         "sv_SE":"Påve bakifrån",
         "en_US":"Pope backside view",
         "da_DK":"Pave bagfra"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":200,
      "height":359,
      "position":5,
      "hidden":2
   },
   {
      "id":"5f088f57-2b4b-4eea-bdea-77949a597a41",
      "logicalname":"content_image_2008.12.10.13.19.50_",
      "translations":{
         "nb_NO":"Prest går",
         "fi_FI":"Pappi kävelee",
         "nn_NO":"Prest går",
         "sv_SE":"Präst går",
         "en_US":"Priest walking",
         "da_DK":"Præst går"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":197,
      "height":362,
      "position":6,
      "hidden":2
   },
   {
      "id":"9d92172c-2a1c-4c5a-bb81-ce52e3cc42a9",
      "logicalname":"content_image_2008.12.10.13.19.59_",
      "translations":{
         "nb_NO":"Prest kneler",
         "fi_FI":"Pappi polvistuu",
         "nn_NO":"Prest kneler",
         "sv_SE":"Präst knäböjer",
         "en_US":"Priest kneeling",
         "da_DK":"Præst knæler"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":220,
      "height":304,
      "position":7,
      "hidden":2
   },
   {
      "id":"f2fc65e2-1b62-4225-b517-0c2a57c9cc6b",
      "logicalname":"content_image_2008.12.10.13.20.06_",
      "translations":{
         "nb_NO":"Prest sitter",
         "fi_FI":"Pappi istuu",
         "nn_NO":"Prest sit",
         "sv_SE":"Präst sitter",
         "en_US":"Priest sitting",
         "da_DK":"Præst sidder"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":176,
      "height":335,
      "position":8,
      "hidden":2
   },
   {
      "id":"4027802a-09b1-479f-9318-62f22daf5916",
      "logicalname":"content_image_2008.12.10.13.20.14_",
      "translations":{
         "nb_NO":"Prest står",
         "fi_FI":"Pappi seisoo",
         "nn_NO":"Prest står",
         "sv_SE":"Präst står",
         "en_US":"Priest standing",
         "da_DK":"Præst står"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":191,
      "height":362,
      "position":9,
      "hidden":2
   },
   {
      "id":"f99b63b7-ca88-4ee5-8bf5-9ed433149c0c",
      "logicalname":"content_image_2008.12.10.13.20.23_",
      "translations":{
         "nb_NO":"Prest syk",
         "fi_FI":"Pappi sairaana",
         "nn_NO":"Prest sjuk",
         "sv_SE":"Präst sjuk",
         "en_US":"Priest sick",
         "da_DK":"Præst syg"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":362,
      "height":137,
      "position":10,
      "hidden":2
   },
   {
      "id":"a76086b6-eb5d-448c-8105-bb8b1a6bd865",
      "logicalname":"content_image_2009.01.20.08.56.09_",
      "translations":{
         "nb_NO":"Prest bakfra",
         "fi_FI":"Pappi takaapäin",
         "nn_NO":"Prest bakfrå",
         "sv_SE":"Präst bakifrån",
         "en_US":"Priest backside view",
         "da_DK":"Præst bagfra"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":216,
      "height":359,
      "position":11,
      "hidden":2
   },
   {
      "id":"95f093df-ff14-4494-8907-6e68b3ea46e2",
      "logicalname":"content_image_2008.12.10.13.16.27_",
      "translations":{
         "nb_NO":"Munk går",
         "fi_FI":"Munkki kävelee",
         "nn_NO":"Munk går",
         "sv_SE":"Munk går",
         "en_US":"Monk walking",
         "da_DK":"Munk går"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":220,
      "height":353,
      "position":12,
      "hidden":2
   },
   {
      "id":"95dc9719-78ca-4e9a-9816-e69b6266f7b6",
      "logicalname":"content_image_2008.12.10.13.16.34_",
      "translations":{
         "nb_NO":"Munk kneler",
         "fi_FI":"Munkki polvistuu",
         "nn_NO":"Munk kneler",
         "sv_SE":"Munk knäböjer",
         "en_US":"Monk kneeling",
         "da_DK":"Munk knæler"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":196,
      "height":289,
      "position":13,
      "hidden":2
   },
   {
      "id":"995be423-db53-4d51-9cc8-bf275ec08b9e",
      "logicalname":"content_image_2008.12.10.13.16.42_",
      "translations":{
         "nb_NO":"Munk sitter",
         "fi_FI":"Munkki istuu",
         "nn_NO":"Munk sit",
         "sv_SE":"Munk sitter",
         "en_US":"Monk sitting",
         "da_DK":"Munk sidder"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":200,
      "height":310,
      "position":14,
      "hidden":2
   },
   {
      "id":"e0f4fd06-4acb-4c45-9382-62ca3aa72905",
      "logicalname":"content_image_2008.12.10.13.16.50_",
      "translations":{
         "nb_NO":"Munk står",
         "fi_FI":"Munkki seisoo",
         "nn_NO":"Munk står",
         "sv_SE":"Munk står",
         "en_US":"Monk standing",
         "da_DK":"Munk står"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":209,
      "height":361,
      "position":15,
      "hidden":2
   },
   {
      "id":"fb27e28a-52b1-4fe0-ad49-8e5415b1d8dc",
      "logicalname":"content_image_2008.12.10.13.16.58_",
      "translations":{
         "nb_NO":"Munk syk",
         "fi_FI":"Munkki sairaana",
         "nn_NO":"Munk sjuk",
         "sv_SE":"Munk är sjuk",
         "en_US":"Monk sick",
         "da_DK":"Munk syg"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":344,
      "height":129,
      "position":16,
      "hidden":2
   },
   {
      "id":"1059e6ed-bb7d-400f-a126-e9b5c6e7c4ed",
      "logicalname":"content_image_2009.01.20.08.55.25_",
      "translations":{
         "nb_NO":"Munk bakfra",
         "fi_FI":"Munkki takaapäin",
         "nn_NO":"Munk bakfrå",
         "sv_SE":"Munk bakifrån",
         "en_US":"Monk backside view",
         "da_DK":"Munk bagfra"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":252,
      "height":336,
      "position":17,
      "hidden":2
   },
   {
      "id":"a71586b6-63cc-42f3-a275-4c51e6ec8089",
      "logicalname":"content_image_2008.12.10.13.18.13_",
      "translations":{
         "nb_NO":"Nonne går",
         "fi_FI":"Nunna kävelee",
         "nn_NO":"Nonne går",
         "sv_SE":"Nunna går",
         "en_US":"Nun walking",
         "da_DK":"Nonne går"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":241,
      "height":365,
      "position":18,
      "hidden":2
   },
   {
      "id":"58d022bb-061f-42ab-98b1-6747447609f3",
      "logicalname":"content_image_2008.12.10.13.18.20_",
      "translations":{
         "nb_NO":"Nonne kneler",
         "fi_FI":"Nunna polvistuu",
         "nn_NO":"Nonne kneler",
         "sv_SE":"Nunna knäböjer",
         "en_US":"Nun kneeling",
         "da_DK":"Nonne knæler"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":237,
      "height":283,
      "position":19,
      "hidden":2
   },
   {
      "id":"81e332a5-579d-4818-973d-4fecb10ee4fb",
      "logicalname":"content_image_2008.12.10.13.18.27_",
      "translations":{
         "nb_NO":"Nonne sitter",
         "fi_FI":"Nunna istuu",
         "nn_NO":"Nonne sit",
         "sv_SE":"Nunna sitter",
         "en_US":"Nun sitting",
         "da_DK":"Nonne sidder"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":190,
      "height":338,
      "position":20,
      "hidden":2
   },
   {
      "id":"b147b550-e474-4563-ae7c-45405c0311ca",
      "logicalname":"content_image_2008.12.10.13.18.36_",
      "translations":{
         "nb_NO":"Nonne står",
         "fi_FI":"Nunna seisoo",
         "nn_NO":"Nonne står",
         "sv_SE":"Nunna står",
         "en_US":"Nun standing",
         "da_DK":"Nonne står"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":224,
      "height":365,
      "position":21,
      "hidden":2
   },
   {
      "id":"5eab5b17-db14-4cdf-84fa-64980fbf9c93",
      "logicalname":"content_image_2008.12.10.13.18.43_",
      "translations":{
         "nb_NO":"Nonne syk",
         "fi_FI":"Nunna sairaana",
         "nn_NO":"Nonne sjuk",
         "sv_SE":"Nunna är sjuk",
         "en_US":"Nun sick",
         "da_DK":"Nonne syg"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":377,
      "height":122,
      "position":22,
      "hidden":2
   },
   {
      "id":"cf3e7fea-778c-4c7b-9806-d0c112bccd2a",
      "logicalname":"content_image_2009.01.20.08.55.49_",
      "translations":{
         "nb_NO":"Nonne bakfra",
         "fi_FI":"Nunna takaapäin",
         "nn_NO":"Nonne bakfrå",
         "sv_SE":"Nunna bakifrån",
         "en_US":"Nun backside view",
         "da_DK":"Nonne bagfra"
      },
      "theme":"middle_age",
      "type":"clergy",
      "moods":[
         "staar",
         "gaar",
         "kneler",
         "sitter"
      ],
      "tags":[
         
      ],
      "width":236,
      "height":363,
      "position":23,
      "hidden":2
   },
   {
      "id":"a28a2967-e46d-46f9-b9f1-cd81f669f58a",
      "logicalname":"ma_ridder1_star_",
      "translations":{
         "nb_NO":"Ridder 1 står",
         "fi_FI":"Ritari 1 reisoo",
         "nn_NO":"Riddar 1 står",
         "sv_SE":"Riddare 1 stående",
         "en_US":"Knight 1 standing",
         "da_DK":"Ridder 1 stående"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":190,
      "height":400,
      "position":0,
      "hidden":2
   },
   {
      "id":"8d2180f9-531e-45b7-b316-a8a3f04bc3cc",
      "logicalname":"ma_ridder1_gar_",
      "translations":{
         "nb_NO":"Ridder 1 går",
         "fi_FI":"Ritari 1 kävelee",
         "nn_NO":"Riddar 1 går",
         "sv_SE":"Riddare 1 gående",
         "en_US":"Knight 1 walking",
         "da_DK":"Ridder 1 gående"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":218,
      "height":395,
      "position":1,
      "hidden":2
   },
   {
      "id":"e8dd4a10-a1f7-4ddd-ae4f-3dedfd76cdc6",
      "logicalname":"ma_ridder1_loper_",
      "translations":{
         "nb_NO":"Ridder 1 løper",
         "fi_FI":"Ritari 1 juoksee",
         "nn_NO":"Riddar 1 spring",
         "sv_SE":"Riddare 1 springande",
         "en_US":"Knight 1 running",
         "da_DK":"Ridder 1 løbende"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":379,
      "height":369,
      "position":2,
      "hidden":2
   },
   {
      "id":"7b0db0ef-d44e-4119-adc9-02f0327fa89e",
      "logicalname":"ma_ridder1_slass_",
      "translations":{
         "nb_NO":"Ridder 1 sloss",
         "fi_FI":"Ritari 1 taistelee",
         "nn_NO":"Riddar 1 slåst",
         "sv_SE":"Riddare 1 stridande",
         "en_US":"Knight 1 fighting",
         "da_DK":"Ridder 1 kæmpende"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":338,
      "height":386,
      "position":3,
      "hidden":2
   },
   {
      "id":"5bc37649-9470-455b-a5f3-b12866ba6b1d",
      "logicalname":"ma_ridder1_kneler_",
      "translations":{
         "nb_NO":"Ridder 1 kneler",
         "fi_FI":"Ritari 1 polvistuu",
         "nn_NO":"Riddar 1 kneler",
         "sv_SE":"Riddare 1 knäböjande",
         "en_US":"Knight 1 kneeling",
         "da_DK":"Ridder 1 knælende"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":312,
      "height":325,
      "position":4,
      "hidden":2
   },
   {
      "id":"12dc190a-331c-496a-8aa6-b6652d537f34",
      "logicalname":"ma_ridder1_til_hest_",
      "translations":{
         "nb_NO":"Ridder 1 til hest",
         "fi_FI":"Ritari 1 hevosen selässä",
         "nn_NO":"Riddar 1 til hest",
         "sv_SE":"Riddare 1 till häst",
         "en_US":"Knight 1 on horse",
         "da_DK":"Ridder 1 til hest"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":223,
      "height":402,
      "position":5,
      "hidden":2
   },
   {
      "id":"9916da9a-fcce-4a47-b7fd-007e93479e5e",
      "logicalname":"ma_ridder2_star_",
      "translations":{
         "nb_NO":"Ridder 2 står",
         "fi_FI":"Ritari 2 reisoo",
         "nn_NO":"Riddar 2 står",
         "sv_SE":"Riddare 2 stående",
         "en_US":"Knight 2 standing",
         "da_DK":"Ridder 2 stående"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":190,
      "height":400,
      "position":6,
      "hidden":2
   },
   {
      "id":"7e86cdb5-4d76-45fa-a62f-7c1008926c7d",
      "logicalname":"ma_ridder2_gar_",
      "translations":{
         "nb_NO":"Ridder 2 går",
         "fi_FI":"Ritari 2 kävelee",
         "nn_NO":"Riddar 2 går",
         "sv_SE":"Riddare 2 gående",
         "en_US":"Knight 2 walking",
         "da_DK":"Ridder 2 gående"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":218,
      "height":395,
      "position":7,
      "hidden":2
   },
   {
      "id":"a9a0fb1e-ddf3-421e-9a46-316a3c123705",
      "logicalname":"ma_ridder2_loper_",
      "translations":{
         "nb_NO":"Ridder 2 løper",
         "fi_FI":"Ritari 2 juoksee",
         "nn_NO":"Riddar 2 spring",
         "sv_SE":"Riddare 2 springande",
         "en_US":"Knight 2 running",
         "da_DK":"Ridder 2 løbende"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":379,
      "height":369,
      "position":8,
      "hidden":2
   },
   {
      "id":"f870a8de-dd5b-461d-9b1b-fa253ee4651e",
      "logicalname":"ma_ridder2_slass_",
      "translations":{
         "nb_NO":"Ridder 2 sloss",
         "fi_FI":"Ritari 2 taistelee",
         "nn_NO":"Riddar 2 slåst",
         "sv_SE":"Riddare 2 stridande",
         "en_US":"Knight 2 fighting",
         "da_DK":"Ridder 2 kæmpende"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":338,
      "height":386,
      "position":9,
      "hidden":2
   },
   {
      "id":"a78701b0-2a5a-4424-8da6-db6821bf6c56",
      "logicalname":"ma_ridder2_kneler_",
      "translations":{
         "nb_NO":"Ridder 2 kneler",
         "fi_FI":"Ritari 2 polvistuu",
         "nn_NO":"Riddar 2 kneler",
         "sv_SE":"Riddare 2 knäböjande",
         "en_US":"Knight 2 kneeling",
         "da_DK":"Ridder 2 knælende"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "forfra",
         "bakfra"
      ],
      "tags":[
         
      ],
      "width":309,
      "height":325,
      "position":10,
      "hidden":2
   },
   {
      "id":"0738acff-75f3-4472-932e-220832399c1d",
      "logicalname":"ma_ridder2_til_hest_",
      "translations":{
         "nb_NO":"Ridder 2 til hest",
         "fi_FI":"Ritari 2 hevosen selässä",
         "nn_NO":"Riddar 2 til hest",
         "sv_SE":"Riddare 2 till häst",
         "en_US":"Knight 2 on horse",
         "da_DK":"Ridder 2 til hest"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":223,
      "height":402,
      "position":11,
      "hidden":2
   },
   {
      "id":"a0177a73-df26-4944-a955-5838d2c932a5",
      "logicalname":"ma_vepner_star_",
      "translations":{
         "nb_NO":"Væpner står",
         "fi_FI":"Aseenkantaja seisoo",
         "nn_NO":"Væpnar står",
         "sv_SE":"Väpnare stående",
         "en_US":"Squire standing",
         "da_DK":"Junker stående"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":145,
      "height":291,
      "position":12,
      "hidden":2
   },
   {
      "id":"497a8bac-5099-4211-8cee-aed6a2778b7d",
      "logicalname":"ma_vepner_gar_",
      "translations":{
         "nb_NO":"Væpner går",
         "fi_FI":"Aseenkantaja kävelee",
         "nn_NO":"Væpnar går",
         "sv_SE":"Väpnare gående",
         "en_US":"Squire walking",
         "da_DK":"Junker gående"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":160,
      "height":284,
      "position":13,
      "hidden":2
   },
   {
      "id":"856b93ce-9f29-4905-b2fa-a55e301bd125",
      "logicalname":"ma_vepner_loper_",
      "translations":{
         "nb_NO":"Væpner løper",
         "fi_FI":"Aseenkantaja juoksee",
         "nn_NO":"Væpnar spring",
         "sv_SE":"Väpnare springande",
         "en_US":"Squire running",
         "da_DK":"Junker løbende"
      },
      "theme":"middle_age",
      "type":"knights",
      "moods":[
         "normal",
         "blid",
         "lei",
         "sint"
      ],
      "tags":[
         
      ],
      "width":202,
      "height":268,
      "position":14,
      "hidden":2
   },
   {
      "id":"4b0d696c-8921-4f16-af05-4d7e98f34efa",
      "logicalname":"content_image_2008.12.10.16.29.18_",
      "translations":{
         "nb_NO":"Hest",
         "fi_FI":"Horse",
         "nn_NO":"Hest",
         "sv_SE":"Häst",
         "en_US":"Horse",
         "da_DK":"Horse"
      },
      "theme":"middle_age",
      "type":"animals",
      "moods":[
         "staar",
         "gaar"
      ],
      "tags":[
         
      ],
      "width":454,
      "height":399,
      "position":0,
      "hidden":2
   },
   {
      "id":"fd687916-e27e-4a1a-9988-23f29dbba51d",
      "logicalname":"content_image_2008.12.10.16.29.36_",
      "translations":{
         "nb_NO":"Ku",
         "fi_FI":"Cow",
         "nn_NO":"Ku",
         "sv_SE":"Ko",
         "en_US":"Cow",
         "da_DK":"Cow"
      },
      "theme":"middle_age",
      "type":"animals",
      "moods":[
         "staar",
         "gaar"
      ],
      "tags":[
         
      ],
      "width":431,
      "height":233,
      "position":2,
      "hidden":2
   },
   {
      "id":"a376012f-40fd-4346-a005-ba434783d8c6",
      "logicalname":"content_image_2008.12.10.16.33.36_",
      "translations":{
         "nb_NO":"Bord",
         "fi_FI":"Pöytä",
         "nn_NO":"Bord",
         "sv_SE":"Bord",
         "en_US":"Table",
         "da_DK":"Bord"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         "forfra",
         "skraa"
      ],
      "tags":[
         
      ],
      "width":356,
      "height":171,
      "position":0,
      "hidden":2
   },
   {
      "id":"9882a3ea-2bff-4332-9c76-36b6bdf58426",
      "logicalname":"content_image_2008.12.10.16.30.23_",
      "translations":{
         "nb_NO":"Brød",
         "fi_FI":"Leipä",
         "nn_NO":"Brød",
         "sv_SE":"Bröd",
         "en_US":"Bread",
         "da_DK":"Brød"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":100,
      "height":19,
      "position":1,
      "hidden":2
   },
   {
      "id":"f7a8e225-face-4d45-a0b3-2e36691ade2c",
      "logicalname":"content_image_2008.12.10.16.30.31_",
      "translations":{
         "nb_NO":"Kopp",
         "fi_FI":"Kuppi",
         "nn_NO":"Kopp",
         "sv_SE":"Kopp",
         "en_US":"Cup",
         "da_DK":"Kop"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":38,
      "height":50,
      "position":2,
      "hidden":2
   },
   {
      "id":"8209205c-95ec-4e83-90e5-b12a2e31efe7",
      "logicalname":"content_image_2008.12.10.16.31.08_",
      "translations":{
         "nb_NO":"Skje",
         "fi_FI":"Lusikka",
         "nn_NO":"Skei",
         "sv_SE":"Sked",
         "en_US":"Spoon",
         "da_DK":"Ske"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":25,
      "height":114,
      "position":3,
      "hidden":2
   },
   {
      "id":"d0d84971-86c3-461c-a2aa-1123160d4a6e",
      "logicalname":"content_image_2008.12.10.16.31.28_",
      "translations":{
         "nb_NO":"Peis",
         "fi_FI":"Takka",
         "nn_NO":"Peis",
         "sv_SE":"Eldstad",
         "en_US":"Fireplace",
         "da_DK":"Pejs"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":193,
      "height":115,
      "position":4,
      "hidden":2
   },
   {
      "id":"8efec937-e960-4476-9513-4e0bcb859b4c",
      "logicalname":"content_image_2008.12.10.16.32.38_",
      "translations":{
         "nb_NO":"Kam",
         "fi_FI":"Kampa",
         "nn_NO":"Kam",
         "sv_SE":"Kam",
         "en_US":"Comb",
         "da_DK":"Kam"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":35,
      "height":29,
      "position":5,
      "hidden":2
   },
   {
      "id":"5b615ca7-1d57-4f0c-a322-34898d129ffe",
      "logicalname":"content_image_2008.12.10.16.32.47_",
      "translations":{
         "nb_NO":"Rebec",
         "fi_FI":"Luuttu",
         "nn_NO":"Rebec",
         "sv_SE":"Rebec",
         "en_US":"Rebec",
         "da_DK":"Rebec"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":133,
      "height":105,
      "position":6,
      "hidden":2
   },
   {
      "id":"598f55aa-cee0-4fad-952d-34530cfa0fcc",
      "logicalname":"content_image_2008.12.10.16.33.18_",
      "translations":{
         "nb_NO":"Skinn",
         "fi_FI":"Nahka",
         "nn_NO":"Skinn",
         "sv_SE":"Läder",
         "en_US":"Leather",
         "da_DK":"Læder"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         "rull",
         "aapent"
      ],
      "tags":[
         
      ],
      "width":224,
      "height":183,
      "position":7,
      "hidden":2
   },
   {
      "id":"d7eaea34-a87b-419b-8c1a-2b9216ed1027",
      "logicalname":"content_image_2008.12.10.16.31.45_",
      "translations":{
         "nb_NO":"Tønne",
         "fi_FI":"Tynnyri",
         "nn_NO":"Tønne",
         "sv_SE":"Tunna",
         "en_US":"Casket",
         "da_DK":"Tønde"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":109,
      "height":151,
      "position":8,
      "hidden":2
   },
   {
      "id":"8048c08e-c394-4149-821c-a00f9b3f3be0",
      "logicalname":"content_image_2008.12.10.16.34.20_",
      "translations":{
         "nb_NO":"Spade",
         "fi_FI":"Shovel",
         "nn_NO":"Spade",
         "sv_SE":"Spade",
         "en_US":"Shovel",
         "da_DK":"Shovel"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":54,
      "height":210,
      "position":9,
      "hidden":2
   },
   {
      "id":"494dd0af-bca8-4908-a9e7-96ae7e4003cf",
      "logicalname":"content_image_2008.12.10.16.32.03_",
      "translations":{
         "nb_NO":"Høygaffel",
         "fi_FI":"Pitchfork",
         "nn_NO":"Høygaffel",
         "sv_SE":"Högaffel",
         "en_US":"Pitchfork",
         "da_DK":"Pitchfork"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":37,
      "height":299,
      "position":10,
      "hidden":2
   },
   {
      "id":"b560e680-dc03-46e9-bfea-5f29eee26dcb",
      "logicalname":"content_image_2008.12.10.16.32.28_",
      "translations":{
         "nb_NO":"Høy",
         "fi_FI":"Heinä",
         "nn_NO":"Høy",
         "sv_SE":"Hög",
         "en_US":"Hay",
         "da_DK":"Hø"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         "hoey",
         "flat"
      ],
      "tags":[
         
      ],
      "width":327,
      "height":121,
      "position":11,
      "hidden":2
   },
   {
      "id":"68aab3dd-f267-420a-b5b7-c897bd8dab29",
      "logicalname":"content_image_2008.12.10.16.32.55_",
      "translations":{
         "nb_NO":"Vogn",
         "fi_FI":"Vaunu",
         "nn_NO":"Vogn",
         "sv_SE":"Vagn",
         "en_US":"Cart",
         "da_DK":"Vogn"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":475,
      "height":176,
      "position":12,
      "hidden":2
   },
   {
      "id":"04ab09be-863a-4876-9b32-4785a922b133",
      "logicalname":"content_image_2009.01.20.08.57.50_",
      "translations":{
         "nb_NO":"Korn",
         "fi_FI":"Vilja",
         "nn_NO":"Korn",
         "sv_SE":"Korn",
         "en_US":"Crops",
         "da_DK":"Korn"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":162,
      "height":144,
      "position":13,
      "hidden":2
   },
   {
      "id":"b8bbdbeb-d75b-4cd2-bac6-cdc0aac5c98f",
      "logicalname":"content_image_2009.01.20.08.57.58_",
      "translations":{
         "nb_NO":"Sigd",
         "fi_FI":"Sirppi",
         "nn_NO":"Sigd",
         "sv_SE":"Skära",
         "en_US":"Sickle",
         "da_DK":"Segl"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":35,
      "height":71,
      "position":14,
      "hidden":2
   },
   {
      "id":"314fac86-c1aa-421c-b86a-070769272ad3",
      "logicalname":"content_image_2008.12.10.16.34.34_",
      "translations":{
         "nb_NO":"Skriftestol",
         "fi_FI":"Rippituoli",
         "nn_NO":"Skriftestol",
         "sv_SE":"Biktstol",
         "en_US":"Confessional ",
         "da_DK":"Skriftestol"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         "forfra",
         "skraa"
      ],
      "tags":[
         
      ],
      "width":360,
      "height":417,
      "position":15,
      "hidden":2
   },
   {
      "id":"8f5842d6-f041-4bc8-99c2-f7fc618258a3",
      "logicalname":"ma_lanse1_",
      "translations":{
         "nb_NO":"Lanse 1",
         "fi_FI":"Peitsi 1",
         "nn_NO":"Lanse 1",
         "sv_SE":"Lans 2",
         "en_US":"Lance 1",
         "da_DK":"Lanse 1"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":520,
      "height":36,
      "position":16,
      "hidden":2
   },
   {
      "id":"7a0c91d6-40a7-4682-9459-bb2a359c4a82",
      "logicalname":"ma_lanse2_",
      "translations":{
         "nb_NO":"Lanse 2",
         "fi_FI":"Peitsi 2",
         "nn_NO":"Lanse 2",
         "sv_SE":"Lans 1",
         "en_US":"Lance 2",
         "da_DK":"Lanse 2"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":521,
      "height":36,
      "position":17,
      "hidden":2
   },
   {
      "id":"676470b3-9e96-4e38-b25b-6bbaa695ecde",
      "logicalname":"ma_flagg1_",
      "translations":{
         "nb_NO":"Flagg 1",
         "fi_FI":"Lippu 1",
         "nn_NO":"Flagg 1",
         "sv_SE":"Fana 2",
         "en_US":"Flag 1",
         "da_DK":"Flag 1"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":132,
      "height":360,
      "position":18,
      "hidden":2
   },
   {
      "id":"e593a47c-1b52-4df4-92e4-0ea95c3223b3",
      "logicalname":"ma_flagg2_",
      "translations":{
         "nb_NO":"Flagg 2",
         "fi_FI":"Lippu 2",
         "nn_NO":"Flagg 2",
         "sv_SE":"Fana 1",
         "en_US":"Flag 2",
         "da_DK":"Flag 2"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":132,
      "height":360,
      "position":19,
      "hidden":2
   },
   {
      "id":"ecc32bad-2098-4285-93f7-728db43692af",
      "logicalname":"ma_skjold1_",
      "translations":{
         "nb_NO":"Skjold 1",
         "fi_FI":"Kilpi 1",
         "nn_NO":"Skjold 1",
         "sv_SE":"Sköld 1",
         "en_US":"Shield 1",
         "da_DK":"Skjold 1"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":126,
      "height":199,
      "position":20,
      "hidden":2
   },
   {
      "id":"f119ecbe-6157-42ec-9a98-ebb10add42df",
      "logicalname":"ma_skjold2_",
      "translations":{
         "nb_NO":"Skjold 2",
         "fi_FI":"Kilpi 2",
         "nn_NO":"Skjold 2",
         "sv_SE":"Sköld 2",
         "en_US":"Shield 2",
         "da_DK":"Skjold 2"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":126,
      "height":199,
      "position":21,
      "hidden":2
   },
   {
      "id":"c06e9423-deed-43d3-b942-2d59ee90d85a",
      "logicalname":"ma_sverd1_",
      "translations":{
         "nb_NO":"Sverd 1",
         "fi_FI":"Miekka 1",
         "nn_NO":"Sverd 1",
         "sv_SE":"Svärd 2",
         "en_US":"Sword 1",
         "da_DK":"Sværd 1"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":63,
      "height":285,
      "position":22,
      "hidden":2
   },
   {
      "id":"cb99e900-1016-49da-aacc-cc0974fd03f3",
      "logicalname":"ma_sverd2_",
      "translations":{
         "nb_NO":"Sverd 2",
         "fi_FI":"Miekka 2",
         "nn_NO":"Sverd 2",
         "sv_SE":"Svärd 1",
         "en_US":"Sword 2",
         "da_DK":"Sværd 2"
      },
      "theme":"middle_age",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":61,
      "height":285,
      "position":23,
      "hidden":2
   }
]`
};


/** WEBPACK FOOTER **
 ** ./docs/newThemeReloaded.js
 **/